import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';

import {ClassesService} from 'app/solar/common/services/classes.service';
import {AddressService} from 'app/solar/common/services/address.service';
import {ContactService} from 'app/solar/common/services/contact.service';
import {CompanyService} from 'app/solar/common/services/company.service';
import {ProductService} from 'app/solar/common/services/product.service';

import {ClassInfoComponent} from 'app/solar/common/class-info/class-info.component';
import { ExamInfoComponent } from './common/exam-info/exam-info.component';

import { AddInstructorComponent } from 'app/solar/common/add-instructor/add-instructor.component';
import { EditVenueConfirmComponent } from 'app/solar/common/edit-venue-confirm/edit-venue-confirm.component';
import { PreviewCertificateComponent } from 'app/shared/components/preview-certificate/preview-certificate.component';
import { MultiCheckBoxComponent } from 'app/solar/common/multi-check-box/multi-check-box.component';
import { GuidanceComponent } from './common/guidance/guidance.component';
import { UberFilterComponent } from './common/uber-filter/uber-filter.component';
import { UberFilterService } from './common/uber-filter/uber-filter.service';
import { UberFilterDataService } from './common/uber-filter/uber-filter-data.service';
import {HappyExamResultsCertificatesComponent} from './common/results-certificates/happy-exam-results-certificates.component';
import {ExamResultsCertificatesService} from './common/results-certificates/exam-results-certificates.service';
import { LicensesSummaryService } from './vouchers/components/licenses/summary/licenses-summary.stub';
import { SolarDropdownComponent } from './common/flexible-dropdown/flexible-dropdown.component';
import { ExamInSessionInfoComponent } from './common/exam-in-session-info/exam-in-session-info.component';
import {SellerSettlementsService} from './seller-exam-fulfillment/settlement-report/seller-settlements.service';
import {CourseService} from './courses/course.service';
import {CourseEventService} from '../common/courses/course-event.service';
import {StepTemplateHostSolarComponent} from './common/steps-template-host-solar/steps-template-host.component';
import {ColorSvgPipeSolar, TypeTileSolarComponent} from './common/type-tile-solar/type-tile.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
    ],
    declarations: [
        ClassInfoComponent,
        AddInstructorComponent,
		ExamInfoComponent,
        EditVenueConfirmComponent,
        MultiCheckBoxComponent,
        GuidanceComponent,
        UberFilterComponent,
        HappyExamResultsCertificatesComponent,
        SolarDropdownComponent,
        ExamInSessionInfoComponent,
        StepTemplateHostSolarComponent,
        TypeTileSolarComponent,
        ColorSvgPipeSolar
    ],
    exports: [
        ClassInfoComponent,
        AddInstructorComponent,
		ExamInfoComponent,
        GuidanceComponent,
        HappyExamResultsCertificatesComponent,
        SolarDropdownComponent,
        SolarDropdownComponent,
        StepTemplateHostSolarComponent,
        TypeTileSolarComponent
    ],
    providers: [
        ClassesService,
        ProductService,
        AddressService,
        SellerSettlementsService,
        ContactService,
        CompanyService,
        UberFilterService,
        UberFilterDataService,
        ExamResultsCertificatesService,
        LicensesSummaryService,
        CourseService,
        CourseEventService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    entryComponents: [
        EditVenueConfirmComponent,
        PreviewCertificateComponent
    ]
})

export class SolarModule {
}



// WEBPACK FOOTER //
// ./src/app/solar/solar.module.ts